import React, { useState, useEffect } from "react";
import { DISTRICTS, STATES } from "@upsolve/shared";
import { Table } from "@upsolve/ui";
import axios from "axios";

import { TD, TH } from "../Tables/TableCells";
import { H5 } from "../Type/Display.h";

const JudgesList = ({ district, state }) => {
  const [judges, setJudges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const source = axios.CancelToken.source();

    const fetchJudges = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${UPSOLVE_API_URL}/v1/content/judges`, {
          cancelToken: source.token,
        });
        setJudges(response.data);
        setError(null);
      } catch (err) {
        if (axios.isCancel(err)) {
          console.log("Request canceled", err.message);
        } else {
          setError("Failed to fetch judges data");
          console.error(`Error fetching judges (${UPSOLVE_API_URL}/v1/content/judges):`, err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchJudges();

    return () => {
      source.cancel("Operation canceled by the user.");
    };
  }, []);

  if (district == null && state == null) return null;
  if (loading) return <div>Loading judges...</div>;
  if (error) return <div>Error: {error}</div>;

  const filteredJudges = judges.filter((judge) => {
    if (state != null) return new RegExp(`^${state.toLowerCase()}`).test(judge.district);
    if (district != null) return district.toLowerCase() === judge.district.toLowerCase();
    return false;
  });

  return (
    <Table size="sm">
      <thead>
        <tr>
          <TH colSpan="2" className="header">
            <H5>{STATES[state.toUpperCase()]} Bankruptcy Judges</H5>
          </TH>
        </tr>
        <tr>
          <TH>District</TH>
          <TH>Judge Name</TH>
        </tr>
      </thead>
      <tbody>
        {filteredJudges.map((judge, index) => (
          <tr key={index}>
            <TD>{DISTRICTS[judge.district] || ""}</TD>
            <TD>Hon. {judge.name}</TD>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default JudgesList;
